import { useQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";

import { airHandlerUnitApi } from "~/api";
import { ExceptionalPlanning, useAirHandlerUnitContext, WeeklyPlanning } from "~/features/air-handler-unit";

export const Route = createFileRoute(
  "/_authenticated/buildings_/$buildingId/air-handler-units/$airHandlerUnitId/settings/planning",
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { buildingId, airHandlerUnitId } = Route.useParams();

  // useQuery (not useSuspenseQuery) so the gateway round-trip never suspends the route — the Planning tab
  // is only reachable once the query is warm, and a background refetch (after a mutation) updates in place.
  // skipGlobalLoader: the slow gateway round-trip must not pop the global "loading" dialog.
  const { data } = useQuery({
    ...airHandlerUnitApi.queries.plannings(airHandlerUnitId),
    meta: { skipGlobalLoader: true },
  });

  const { airHandlerUnit, airHandlerUnits } = useAirHandlerUnitContext(Route.id);

  return (
    <div className="gap-10 flex h-full w-full flex-col overflow-auto">
      <form className="gap-10 flex w-full flex-row *:flex-1">
        <WeeklyPlanning
          buildingId={buildingId}
          airHandlerUnit={airHandlerUnit}
          airHandlerUnits={airHandlerUnits}
          plannings={data?.plannings ?? []}
        />
      </form>
      <ExceptionalPlanning
        buildingId={buildingId}
        airHandlerUnit={airHandlerUnit}
        airHandlerUnits={airHandlerUnits}
        planningExceptions={data?.planningExceptions ?? []}
      />
    </div>
  );
}
